import { Nullable } from '@types'

import CloseIcon from '@mui/icons-material/Close'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Popover from '@mui/material/Popover'
import Typography from '@mui/material/Typography'

export interface NoticePopoverProps {
  id?: string
  anchor: Nullable<Element>
  onClose: () => void
  title: string
  text: string
}

const NoticePopover = (props: NoticePopoverProps) => {
  const { id, anchor, title, text, onClose } = props

  return (
    <Popover
      id={id}
      open={!!anchor}
      anchorEl={anchor}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      sx={{
        padding: '20px',
        marginTop: '10px',
      }}
    >
      <Box padding="20px" width="234px" position="relative">
        <Box mb="10px">
          <Typography variant="h2">{title}</Typography>
        </Box>

        <Typography variant="body1">{text}</Typography>
        <Box position="absolute" top="10px" right="10px">
          <IconButton onClick={onClose}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
      </Box>
    </Popover>
  )
}

export default NoticePopover
